import clientService from '../services/client.service'

const handlers = {
  client: {
    set: 'client_set'
  }
}

const initVuexState = function(state) {
  state.client = null;
}

const initGetters = function(getters) {
  getters.client = (state => state.client);
}

const initActions = function(actions) {
  actions[handlers.client.set] = ({ commit }, client) => { commit(handlers.client.set, client); };
}

const initMutations = function(mutations) {
  mutations[handlers.client.set] = (state, client) => (state.client = client);
}

let clientPromise = null;

const initAppState = function (appState, store) {
  let clientAppState = {
    get: () => store.getters.client,
    ensure: () => {
      if (!clientPromise) {
        
        clientPromise = clientService.get();

        clientPromise && clientPromise.then(client => {
          store.dispatch(handlers.client.set, client);
        });
      }

      return clientPromise;
    }
  }

  appState.client = clientAppState;
};

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/client.js